export const isVariationAttributeSelectionValid = (attribute) => {
    const selectedValue = attribute?.selectedValue?.value

    if (!selectedValue) {
        return false
    }

    if (!attribute?.values?.length) {
        return true
    }

    return attribute.values.some((value) => value.value === selectedValue)
}

export const hasAllValidVariationSelections = (variationAttributes = []) =>
    variationAttributes.length > 0 &&
    variationAttributes.every(isVariationAttributeSelectionValid)
